/**
 * Fixed page backdrop: slow-drifting aurora blobs in the site palette,
 * a faint dotted grid, and static film grain. CSS-only, no canvas loop.
 */
export function AuroraBackground() {
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-ink">
      <div className="absolute -left-[10%] -top-[20%] h-[70vh] w-[70vw] animate-aurora rounded-full bg-[radial-gradient(closest-side,rgba(196,181,253,0.18),transparent)] blur-3xl" />
      <div
        className="absolute -right-[15%] top-[10%] h-[60vh] w-[60vw] animate-aurora rounded-full bg-[radial-gradient(closest-side,rgba(255,179,217,0.12),transparent)] blur-3xl"
        style={{ animationDelay: '-6s' }}
      />
      <div
        className="absolute bottom-[-25%] left-[20%] h-[60vh] w-[60vw] animate-aurora rounded-full bg-[radial-gradient(closest-side,rgba(135,206,235,0.10),transparent)] blur-3xl"
        style={{ animationDelay: '-12s' }}
      />

      {/* dotted grid, fading toward the bottom */}
      <div
        className="absolute inset-0 opacity-[0.35] [mask-image:radial-gradient(ellipse_80%_60%_at_50%_0%,black,transparent)]"
        style={{
          backgroundImage: 'radial-gradient(rgba(255,255,255,0.12) 1px, transparent 1px)',
          backgroundSize: '28px 28px',
        }}
      />

      {/* film grain */}
      <div
        className="absolute inset-0 opacity-[0.05] mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
        }}
      />
    </div>
  )
}
